export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20product%20collage%20with%20colorful%20fashion%20items%20sneakers%20hoodies%20caps%20and%20accessories%20scattered%20artistically%20on%20warm%20cream%20textured%20surface%20soft%20diffused%20sunlight%20from%20left%20editorial%20creative%20photography%20warm%20neutral%20tones%20clean%20airy%20composition%20with%20generous%20negative%20space%20on%20right&width=1600&height=700&seq=cta-bg-unique-2026&orientation=landscape"
          alt="HoobuySpreadsheet - Encontre os melhores produtos"
          title="HoobuySpreadsheet - Produtos selecionados"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/25"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          {/* Left: Title */}
          <div className="max-w-lg">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-4 drop-shadow-md">
              Pronto para Encontrar os Melhores Produtos?
            </h2>
            <p className="text-white/75 text-sm md:text-base max-w-md">
              Acesse agora o <strong className="text-white">hoobuyspreadsheet</strong> completo e comece a economizar nas suas compras da China.
            </p>
          </div>

          {/* Right: Button */}
          <div className="flex-shrink-0">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-950 font-bold text-sm md:text-base rounded-full hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer group shadow-lg"
            >
              buy it now
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950 text-white group-hover:bg-primary-500 transition-colors duration-200">
                <i className="ri-arrow-right-line text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}